import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams, useNavigate, NavLink } from "react-router-dom";
import {
    Grid,
    Container,
    Paper,
    Typography,
    Divider,
    IconButton,
    Icon,
} from "@mui/material";
import { Loading, Tabs, TabContainer, Tooltip } from "@gpstrackit/react-controls"
import { useIntl } from "react-intl";

//Actions
import {
    dealergetDataRequest,
    dealersCreateEditDealerOpenModal,
    clearRedux,
} from "Redux/actions";

//Components
import ChipStatus from 'Components/ChipStatus';
import SummaryCard from 'Components/SummaryCard';
import MultiLevelSelector from "Components/SelectorMultiLevel";
//Tabs
import Activities from "Modules/activities/.components/tab";
import Accounts from "Modules/accounts/.components/tab";
import Packages from "Modules/packages/.components/tab";
import BillingAccounts from "Modules/dealers/views/.components/billingAccountsTab";
import DealerAlertLogs from "Modules/dealers/views/.components/dealerAlertLogsTab";
import WebHooks from "Modules/dealers/views/.components/webHooksTab";

//Views
import CreateEditDealer from 'Modules/dealers/views/.components/createEditDealer';

//Helpers
import { getDateFormatted, copyToClipboard } from 'Core/data/Helpers';
import { endpoints } from 'Core/defaultValues';
//Permission
import { HasPermission } from "Core/security"
import { de } from "date-fns/locale";

const DealerOverview = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();
    const navigate = useNavigate();

    const { loading, dealer } = useSelector(state => state.dealerOverviewRedux);
    const createEditDealerOModal = useSelector(state => state.createEditDealerRedux.openModal);
    const user = useSelector(state => state.securityRedux.user);

    const { id } = useParams();
    const [tab, setTab] = useState(0);
    const [openSummary, setOpenSummary] = useState(true);

    useEffect(() => {
        dispatch(dealergetDataRequest(id))
        return () => {
            dispatch(clearRedux("DEALER_OVERVIEW"));
            dispatch(clearRedux("COMMON", {
                'companies-tab': {},
                'packages-tab': {}
            }))
        }
    }, [])

    const SummaryItem = (props) => {
        const { label, value } = props;
        return (
            <Grid item xs={4} sm={4}>
                <div style={{ display: 'grid' }}>
                    <span style={{ opacity: 0.6 }} className="text-muted mb-2">
                        {label}
                    </span>
                    {
                        dealer ? value() : <div style={{ width: 210, height: 20 }}></div>
                    }
                </div>
            </Grid>
        )
    }


    let activitiesTab = HasPermission(user, "act");
    let accountsTab = HasPermission(user, "cmp");
    let packagesTab = HasPermission(user, "rol");
    let billingAccountsTab = HasPermission(user, "bllngaccnts");
    let dealerAlertLogsTab = HasPermission(user, "dalertlog");
    let webHooksTab = HasPermission(user, "dwbhook");

    let indexCount = 0;

    let innerHeight = window.innerHeight

    return (
        <Container maxWidth={false} className="container-view">
            {loading && <Loading overlay show />}
            <Paper elevation={0}>
                <Grid
                    container
                    direction="row"
                    style={{ padding: "14px 18px", borderBottom: "1px solid #e8e8e8" }}
                >
                    <Grid item xs={12} style={{ textAlign: 'left' }}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="space-between"
                            alignItems="center"
                        >
                            <Grid item xs={6}>
                                <Typography variant="h5" component="div" style={{ display: 'flex', alignItems: 'center' }}>
                                    <IconButton onClick={() => navigate(-1)} size="large">
                                        <Icon style={{ cursor: "pointer" }} className="toolbar-list-icon">
                                            arrow_back
                                        </Icon>
                                    </IconButton>
                                    <span style={{ marginRight: 5, opacity: 0.6 }}>{messages['dealer_overview_title']}:</span> {dealer?.name ? `${dealer?.name?.substring(0, 30)} (${dealer.id})` : ''}
                                </Typography>
                            </Grid>
                            <Grid item xs={6} style={{ textAlign: 'end' }}>
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <MultiLevelSelector
                                        label={messages['dealer_overview_actions']}
                                        position="left"
                                        options={[
                                            {
                                                id: "edit_dealer",
                                                label: messages['dealer_overview_edit_dealer'],
                                                show: true,
                                                action: () => {
                                                    dispatch(dealersCreateEditDealerOpenModal(dealer))
                                                },
                                                disabled: !HasPermission(user, "dea", "u"),
                                            }
                                        ]}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <Divider style={{ backgroundColor: '#999999' }} />
                            </Grid>
                        </Grid>
                        <SummaryCard
                            onChange={(value) => setOpenSummary(value)}
                            name="dealers-summary"
                        >
                            <Grid container>
                                <SummaryItem
                                    label={messages['dealer_overview_username']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                {dealer?.username}
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['dealer_overview_email']}
                                    value={() => {
                                        return (
                                            <div style={{ height: 25, display: 'flex' }}>
                                                {dealer?.email &&
                                                    <>
                                                        <span>{dealer?.email}</span>
                                                        <Icon style={{ cursor: "pointer", marginLeft: 5, color: 'rgba(0, 0, 0, 0.54)', fontSize: 18 }} className="toolbar-list-icon" onClick={() => { copyToClipboard(dealer?.email, messages['common_copied']) }}>
                                                            content_copy
                                                        </Icon>
                                                    </>
                                                }
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['dealer_overview_master_company']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 260, height: 25, whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
                                                <NavLink to={`/app/accounts/overview/${dealer?.masterCompany?.id}`} style={{ color: 'black' }}>
                                                    <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>{dealer?.masterCompany?.name}</span>
                                                </NavLink>
                                            </div>
                                        )
                                    }}
                                />
                                <SummaryItem
                                    label={messages['dealer_overview_crm']}
                                    value={() => {
                                        return (
                                            <div style={{ width: 210, height: 25 }}>
                                                <a
                                                    style={{ color: 'black' }}
                                                    href={`${endpoints.SALESFORCE_URL}lightning/r/Account/${dealer?.masterCompany?.crmId}/view`}
                                                    target="_blank"
                                                >
                                                    {dealer?.crmId}
                                                </a>

                                            </div>
                                        )
                                    }}
                                />
                            </Grid>
                        </SummaryCard>

                        <Tabs onChange={(numberTab) => { setTab(numberTab) }}>

                            {
                                accountsTab &&
                                <TabContainer index={indexCount++} key={`menu-${0}`} label={messages['dealer_overview_tab_accounts']}>
                                    {dealer?.id &&
                                        <Accounts
                                            tab={tab}
                                            dealerId={dealer?.id}
                                            height={openSummary ? innerHeight - 447 : innerHeight - 257}
                                            paramDealer={dealer}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                activitiesTab &&
                                <TabContainer index={indexCount++} key={`menu-${1}`} label={messages['dealer_overview_activities']}>
                                    {dealer?.id &&
                                        <Activities
                                            tab={tab}
                                            entityName="Dealer"
                                            entityId={dealer?.id}
                                            companyId={dealer?.masterCompany?.id}
                                            companyName={dealer?.masterCompany?.name}
                                            height={openSummary ? innerHeight - 447 : innerHeight - 257}
                                            noFilters
                                            noOpenSearch
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                packagesTab &&
                                <TabContainer index={indexCount++} key={`menu-${2}`} label={messages['dealer_overview_tab_packages']}>
                                    {dealer?.id &&
                                        <Packages
                                            tab={tab}
                                            dealerId={dealer?.id}
                                            height={openSummary ? innerHeight - 447 : innerHeight - 257}
                                            paramDealer={dealer}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                billingAccountsTab &&
                                <TabContainer index={indexCount++} key={`menu-${3}`} label={messages['dealer_overview_tab_billing_accounts']}>
                                    {dealer?.id &&
                                        <BillingAccounts
                                            tab={tab}
                                            dealerId={dealer?.id}
                                            height={openSummary ? innerHeight - 447 : innerHeight - 257}
                                            paramDealer={dealer}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                webHooksTab &&
                                <TabContainer index={indexCount++} key={`menu-${5}`} label={messages['dealer_overview_tab_webhooks']}>
                                    {dealer?.id &&
                                        <WebHooks
                                            tab={tab}
                                            dealerId={dealer?.id}
                                            height={openSummary ? innerHeight - 447 : innerHeight - 257}
                                            paramDealer={dealer}
                                        />
                                    }
                                </TabContainer>
                            }
                            {
                                dealerAlertLogsTab &&
                                <TabContainer index={indexCount++} key={`menu-${4}`} label={messages['dealer_overview_tab_alert_logs']}>
                                    {dealer?.id &&
                                        <DealerAlertLogs
                                            tab={tab}
                                            dealerId={dealer?.id}
                                            height={openSummary ? innerHeight - 447 : innerHeight - 257}
                                            paramDealer={dealer}
                                        />
                                    }
                                </TabContainer>
                            }
                        </Tabs>
                    </Grid>
                </Grid>
            </Paper>
            {createEditDealerOModal && <CreateEditDealer getDealer={() => dispatch(dealergetDataRequest(id))} />}

        </Container>
    );
}
export default DealerOverview;